import _ from 'lodash';
import { useTranslation } from 'react-i18next';
import useFormatter from '../../common/useFormatter';
import { getItemStatsMetricDescriptorsMap } from './itemStatsMetric.default';
import {
  ItemStatsMetric,
  ItemStatsMetricDescriptor,
} from './itemStatsMetric.types';

function useItemStatsMetricDescriptorsMap() {
  const { t } = useTranslation('app');
  const formatter = useFormatter();
  // const extraDescriptors = useRecoilValue(actualityExtraMetricDescriptors);

  const metrics: ItemStatsMetricDescriptor[] = [
    {
      ...getItemStatsMetricDescriptorsMap(t).categoryABC,
      category: 'velocity',
      title: t`ABC`,
    },
    {
      ...getItemStatsMetricDescriptorsMap(t).orderLineCount,
      category: 'orderStats',
      title: t`Order Line Count`,
    },
    {
      ...getItemStatsMetricDescriptorsMap(t).orderLineCount,
      category: 'orderStats',
      title: t`Order Line Count`,
    },
    {
      ...getItemStatsMetricDescriptorsMap(t).quantityOrdered,
      category: 'orderStats',
      title: t`Quantity Ordered`,
    },
    {
      ...getItemStatsMetricDescriptorsMap(t).percentRank,
      category: 'orderStats',
      title: t`ABC (Percent Rank)`,
    },
    {
      ...getItemStatsMetricDescriptorsMap(t).cumulativePercentRank,
      category: 'orderStats',
      title: t`Cumulative Percent Rank`,
    },
    {
      ...getItemStatsMetricDescriptorsMap(t).totalDaysOrdered,
      category: 'orderStats',
      title: t`Total Days Ordered`,
    },
    {
      ...getItemStatsMetricDescriptorsMap(t).totalWeeksOrdered,
      category: 'orderStats',
      title: t`Total Weeks Ordered`,
    },
    {
      ...getItemStatsMetricDescriptorsMap(t).maxDailyLinesCount,
      category: 'orderStats',
      title: t`Max Daily Lines Count`,
    },
    {
      ...getItemStatsMetricDescriptorsMap(t).minDailyLinesCount,
      category: 'orderStats',
      title: t`Min Daily Lines Count`,
    },
    {
      ...getItemStatsMetricDescriptorsMap(t).avgDailyLinesCount,
      category: 'orderStats',
      title: t`Avg Daily Lines Count`,
    },
    {
      ...getItemStatsMetricDescriptorsMap(t).maxWeeklyLinesCount,
      category: 'orderStats',
      title: t`Max Weekly Lines Count`,
    },
    {
      ...getItemStatsMetricDescriptorsMap(t).minWeeklyLinesCount,
      category: 'orderStats',
      title: t`Min Weekly Lines Count`,
    },
    {
      ...getItemStatsMetricDescriptorsMap(t).avgWeeklyLinesCount,
      category: 'orderStats',
      title: t`Avg Weekly Lines Count`,
    },

    // ...(extraDescriptors as any),
  ];

  const titled = _(metrics)
    .map(d => ({ ...d, titleCategory: t`Item Stats`, subTitle: t`Item` }))
    .keyBy(d => d.type)
    .value() as Record<ItemStatsMetric, ItemStatsMetricDescriptor>;
  return titled;
}

export default useItemStatsMetricDescriptorsMap;
